module.exports = __webpack_public_path__ + "img/ru.9bdbca3f.jpg";